import styled from '@emotion/styled'

export default styled('span')`
  font-size: ${props => props.theme.spacing['7']};
  letter-spacing: 0.15384615rem;
`
